import React, { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images = [], index = 0, onClose, onIndexChange, alt = "" }) => {
  const open = index !== null && index >= 0;

  const prev = useCallback((e) => {
    e && e.stopPropagation();
    onIndexChange((index - 1 + images.length) % images.length);
  }, [index, images.length, onIndexChange]);

  const next = useCallback((e) => {
    e && e.stopPropagation();
    onIndexChange((index + 1) % images.length);
  }, [index, images.length, onIndexChange]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, onClose, prev, next]);

  if (!open) return null;

  return (
    <div data-testid="lightbox" onClick={onClose}
      className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 md:p-8 animate-[fadeIn_0.2s_ease]">
      <button data-testid="lightbox-close" onClick={onClose} aria-label="Close"
        className="absolute top-4 right-4 md:top-6 md:right-6 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
        <X className="w-6 h-6" />
      </button>

      {images.length > 1 && (
        <>
          <button data-testid="lightbox-prev" onClick={prev} aria-label="Previous"
            className="absolute left-3 md:left-6 w-11 h-11 md:w-14 md:h-14 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            <ChevronLeft className="w-6 h-6 md:w-8 md:h-8" />
          </button>
          <button data-testid="lightbox-next" onClick={next} aria-label="Next"
            className="absolute right-3 md:right-6 w-11 h-11 md:w-14 md:h-14 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            <ChevronRight className="w-6 h-6 md:w-8 md:h-8" />
          </button>
        </>
      )}

      <img src={images[index]} alt={alt} onClick={(e) => e.stopPropagation()}
        className="max-h-[88vh] max-w-[92vw] object-contain rounded-lg shadow-2xl" />

      {images.length > 1 && (
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 px-4 py-1.5 rounded-full bg-white/10 text-white text-sm">
          {index + 1} / {images.length}
        </div>
      )}
    </div>
  );
};

export default Lightbox;
